// extracted by mini-css-extract-plugin
module.exports = {"exceptionPage":"mIndex_exceptionPage__SXA0_","title":"mIndex_title__SYH8R","description":"mIndex_description__E44jD","button":"mIndex_button__gAJZF"};